import { axiosWrapper } from "../../axiosWrapper";
import {
  ICreateQuotePayload,
  IEditQuotePayload,
  IQuotationAdyenPaymentPayload,
  IQuotePlayload,
} from "../../pages/Quotation/Common/Interfaces/IQuotePayload";
import { ISearchFor } from "../../pages/Quotation/Common/Interfaces/ISearchFor";
import { ISignQuotationPayload } from "../../pages/Quotation/Components/SignQuotationComponent/SignQuotationComponent.types";
import { IQuotationPayload } from "../../pages/Quotation/Quotation.types";
export class QuotationService {
  public static async getAllQuotation(quotationPayload: IQuotationPayload) {
    // return await axiosWrapper.Post(
    //   `Quotations/QuotesSearch/`, quotationPayload
    // );
    return await axiosWrapper.Post(`Quotations/List`, quotationPayload);
  }

  public static async deleteQuote(quoteSearch: ISearchFor) {
    // return await axiosWrapper.Delete(`Quotations/DeleteQuote/${quoteSearch.searchText}/${quoteSearch.partitionKey}`);
    return await axiosWrapper.Delete(
      `Quotations/Delete/${quoteSearch.searchText}/${quoteSearch.partitionKey}`
    );
  }

  public static async updateQuotationStatus(
    quoteId: string,
    partitionKey: string,
    quoteStatus: string
  ) {
    // return await axiosWrapper.Post(
    //   `Quotations/QuoteActions/${quoteId}/${quoteStatus}`
    // );
    return await axiosWrapper.Patch(
      `Quotations/Status/${quoteId}/${partitionKey}/${quoteStatus}`
    );
  }

  public static async validateMsxOppertunityId(id: string) {
    return await axiosWrapper.Get(`MSX/ValidateMSXOppertunityId/${id}`);
  }

  public static async createQuotation(
    createQuote: ICreateQuotePayload | IQuotePlayload
  ) {
    // return await axiosWrapper.Post('Quotations/QuoteCreation/', createQuote);
    return await axiosWrapper.Post("Quotations/", createQuote);
  }

  public static async editQuotation(
    editQuote: IEditQuotePayload | IQuotePlayload
  ) {
    // return await axiosWrapper.Patch(`Quotations/EditQuotation/${editQuote.quoteHeader.id}`, editQuote);
    return await axiosWrapper.Post(
      `Quotations/Edit/${editQuote.quoteHeader.id}`,
      editQuote
    );
  }

  public static async addAdyenPaymentLink(
    adyenPayment: IQuotationAdyenPaymentPayload
  ) {
    return await axiosWrapper.Post(
      `Quotations/AddAdyenPaymentLink`,
      adyenPayment
    );
  }

  public static async getRecentQuoteCustomers() {
    return await axiosWrapper.Get(`Quotations/RecentQuotesCustomers`);
  }

  public static async searchCustomerInfo(searchText: string) {
    return await axiosWrapper.Get(
      `CustomerAccount/SearchCustomerInfo/${searchText}`
    );
  }

  public static async signQuotation(signQuote: ISignQuotationPayload) {
    return await axiosWrapper.Patch(`Quotations/SignQuote`, signQuote);
  }

  public static async getQuoteNumber() {
    return await axiosWrapper.Get(`Quotations/MSEFriendlyQuoteNumber`);
  }

  public static async getCustomerManualDiscount(customerAccountId: string) {
    return await axiosWrapper.Get(
      `CustomerAccount/CustomerManualDiscount/${customerAccountId}`
    );
  }
}
